RivalIQ.apps.AccountSettings.module('controller', function (controller, App, Backbone, Marionette, $, _) {

    'use strict';

    const Router = Marionette.AppRouter.extend({
        appRoutes: {
            ':tab': 'setActiveTab'
        }
    });

    const Controller = Marionette.Controller.extend({
        start: function () {
            const me = this;

            me.listenTo(App, 'export', me.onExport);

            me.subscription = new App.views.Subscription({
                model: RivalIQ.state.account,
                el: '#subscription-content'
            });

            App.subscription.show(me.subscription);

            $('.x-trigger-intercom').on('click', me.showIntercom);

            // for the subscription tab, the content is static and thus often available before the shell is loaded.
            // So we have it hidden in the template then shown here (after the shell has loaded); otherwise, the user
            // could see that content first, then see the shell load around it a moment later.
            $('#accountSettings').show();

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.V3ViewedAccountSettings);
        },

        setActiveTab: function (tab) {
            const me = this;
            if (tab === 'payment-entry') {
                me.showPaymentEntry();
            }
            $(`a[href="#${tab}"]`).tab('show');
        },

        showIntercom: function () {
            if (window.Intercom) {
                window.Intercom('show');
            }
        },

        showPaymentEntry: function () {
            App.paymentEntry.showLoading();

            const cardSummary = new App.models.CardSummary();

            cardSummary.fetch().then(function (summary) {
                const view = new App.views.PaymentEntry({
                    currentCard: summary
                });
                App.paymentEntry.show(view);
            }, function (resp) {
                if (resp.status === 404) {
                    App.paymentEntry.show(new App.views.PaymentEntry());
                } else {
                    RivalIQ.execute('alert:danger', 'An error occurred, please try again');
                }
            });
        }
    });

    controller.addInitializer(function (options) {

        const controller = new Controller(options);
        new Router({
            controller: controller
        });
        controller.start(options);
    });
});
